import { HereMapsService } from '../..';
import EndEventInfoContent from './EndEventInfoContent';

const { H } = HereMapsService;

export default (tripDetails = {}, event, vehicle, onClose, t, config) => {
  const {
    vehicleCompany, licencePlateNumber, id: vehicleId, lastPosition,
  } = vehicle.vehicle;
  const { name: companyName } = vehicleCompany || {};
  const { avgSpeed } = tripDetails;
  const {
    location, duration, startTimestamp, endTimestamp, type, ads: eventAds,
  } = event;
  const fallbackAds = (lastPosition && lastPosition.length > 0 && lastPosition[0].ads) ? lastPosition[0].ads : null;
  const ads = eventAds || fallbackAds || null;
  const infoBubble = new H.ui.InfoBubble({
    lat: location.position.latitude,
    lng: location.position.longitude,
  }, {
    content: EndEventInfoContent({
      type,
      duration,
      startTimestamp,
      endTimestamp,
      companyName,
      licencePlateNumber,
      location,
      avgSpeed,
      vehicleId,
      onClose,
      config,
      ads,
    }, t),
  });
  infoBubble.addClass('trip-info-infobubble');
  infoBubble.addClass('above-marker-infobubble');
  infoBubble.close();
  return infoBubble;
};
